import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
import { Snackbar } from '../../components/atoms/Snackbar';
import SnackbarStack from './SnackbarStack';
const SnackbarContext = createContext(undefined);
export const WithSnackbar = ({ children, maxStack = 3, ...snackbarProviderProps }) => {
    const [snackbarQueue, setSnackbarQueue] = useState([]);
    const handleClose = (event, reason, index) => {
        if (reason === 'clickaway') {
            return;
        }
        const closedSnackbar = snackbarQueue[index];
        closedSnackbar?.onClose?.(event, reason);
        snackbarProviderProps.onClose?.(event, reason);
        setSnackbarQueue(prevQueue => prevQueue.filter((_, i) => i !== index));
    };
    const showSnackbar = ({ message, severity, error, }) => {
        if (snackbarQueue.length >= maxStack) {
            handleClose(new Event(''), undefined, 0);
        }
        if (severity === 'error' || error) {
            const context = {
                sessionId: sessionStorage.getItem('sessionId'),
                workstationId: sessionStorage.getItem('workstationId'),
                warehouseCode: sessionStorage.getItem('warehouseCode'),
                error,
            };
            console.error(message, context);
        }
        setSnackbarQueue(prevQueue => [...prevQueue, { message, severity, key: new Date().getTime() }]);
    };
    return (_jsxs(SnackbarContext.Provider, { value: { showSnackbar }, children: [children, _jsx(SnackbarStack, { positionVertical: snackbarProviderProps.positionVertical, positionHorizontal: snackbarProviderProps.positionHorizontal, children: snackbarQueue.map(({ key, ...snackbarProps }, index) => (_jsx(Snackbar, { isOpen: true, onClose: (event, reason) => handleClose(event, reason, index), ...snackbarProviderProps, ...snackbarProps }, key))) })] }));
};
export const useSnackbar = () => {
    const context = useContext(SnackbarContext);
    if (!context) {
        throw new Error('useSnackbar must be used within a WithSnackbar provider');
    }
    return context.showSnackbar;
};
//# sourceMappingURL=index.js.map